import "../style.css";
import React from "react";
import PanelContent from "../components/PanelContent";

export default function Verdict() {
  return (
    <PanelContent
      id="verdict_panel"
      route="/verdict"
      frTitle = "Le verdict"
      enTitle = "The Verdict"
      frSubtitle = "Un jugement sous tension"
      enSubtitle = "A Trial Under Pressure"
      frText = "En janvier 1977, Robert Badinter réitère son plaidoyer. Il dénonce la brutalité des exécutions et rappelle que tuer ne préviendrait pas d'autres crimes : 'Si vous le coupez en deux, ça ne dissuadera rien ni personne.' Le verdict est surprenant : Patrick Henry est reconnu coupable, mais il est condamné à la réclusion criminelle à perpétuité, pas à la peine de mort."
      enText = "In January 1977, Robert Badinter reiterated his plea. He denounced the brutality of executions and emphasized that killing would not prevent further crimes: 'If you cut him in two, it will deter nothing and no one.' The verdict was surprising: Patrick Henry was found guilty but sentenced to life imprisonment, not the death penalty."
      frLeftButton=""
      enLeftButton = ""
      frRightButton="Terminer"
      enRightButton = "Complete"
      prev="/manifestants"
      next="/"
    />
  );
}
